import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, CheckCircle } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '"No tengo tiempo por las mañanas."',
    a: 'Justamente por eso creamos este método de 10 minutos. Está hecho para personas ocupadas que necesitan resultados reales.'
  }, {
    q: '"¿Esto es para una religión específica?"',
    a: 'Es para cualquier persona que crea en Dios y quiera fortalecer su relación con Él basada en principios bíblicos universales.'
  }, {
    q: '"¿Cómo recibo el material?"',
    a: 'Es 100% digital. Recibirás un correo con acceso inmediato a todos los PDFs para leer en tu celular, tablet o imprimir.'
  }];
  return <section className="py-10 md:py-20 px-4 bg-white" data-id="element-47">
      <div className="max-w-3xl mx-auto" data-id="element-48">
        <div className="text-center mb-6 md:mb-12" data-id="element-49">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-teal-dark mb-4" data-id="element-50">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 h-1 bg-gold mx-auto rounded-full" data-id="element-51"></div>
        </div>

        <div className="space-y-4" data-id="element-52">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-53">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 bg-gray-50 hover:bg-cream transition-colors text-left" data-id="element-54">
                <span className="font-bold text-lg text-teal-dark" data-id="element-55">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-gold transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-56" />
              </button>

              <AnimatePresence data-id="element-57">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-58">
                    <div className="p-6 bg-white border-t border-gray-100 flex gap-3" data-id="element-59">
                      <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-60" />
                      <p className="text-charcoal/80 text-lg" data-id="element-61">{faq.a}</p>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}